import useAuthentication from "@dpa-connect/dpa-id-user/compositions/useAuthentication";
import store from "@/store";

export default useAuthentication(store);
